<template>
  <div class="contents_wrapper">
    <div class='contents'>
      <h2 class="large_label">ユーザー情報変更</h2>

      <p class="bold_label">扱えるソフトウェア</p>
      <ParentChildChecksBox :prop-parents="renewUserDetail.softwares" :reload-key="reloadKey" :is-visible-children="true"/>

      <p class="bold_label">スキル</p>
      <ParentChildChecksBox :prop-parents="renewUserDetail.skills" :reload-key="reloadKey" :is-visible-children="true"/>

      <button @click="updateUserDetail()" class="active-rectangle_button">ユーザー情報を登録</button>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import ParentChildChecksBox from "@/components/molecules/box/form/ParentChildChecksBox";
  import SOFTWARES from "@/assets/js/constants/softwares";
  import SKILLS from "@/assets/js/constants/skills";
  import collection from "@/assets/js/functions/firebase/firestore/collection";
  import COLLECTION_NAMES from "@/assets/js/constants/collection_names";

  export default {
    name: "RegisterUserSkill",

    mixins: [collection],

    components: {ParentChildChecksBox},

    data() {
      return {
        userDetail: null,
        reloadKey: false,
        renewUserDetail: {
          softwares: {},
          skills: {},
        },
      }
    },


    computed: {
      ...mapGetters({uid: 'auth/uid'}),
    },

    beforeCreate() {
      Object.assign(this, {COLLECTION_NAMES});

      Object.assign(this, {SOFTWARES});
      for (let [key] of Object.entries(SOFTWARES)) {
        SOFTWARES[key]['isSelected'] = false;

        for (let [child_key] of Object.entries(SOFTWARES[key].children)) {
          SOFTWARES[key].children[child_key]['isSelected'] = false;
        }
      }

      Object.assign(this, {SKILLS});
      for (let [key] of Object.entries(SKILLS)) {
        SKILLS[key]['isSelected'] = false;

        for (let [child_key] of Object.entries(SKILLS[key].children)) {
          SKILLS[key].children[child_key]['isSelected'] = false;
        }
      }
    },
    created() {
      this.renewUserDetail.softwares = SOFTWARES;
      this.renewUserDetail.skills = SKILLS;
    },

    async mounted() {
      await this.getDoc(
        COLLECTION_NAMES.USER_DETAILS,
        this.uid,
        {}).then(async readUserDetail => {
        if (readUserDetail) {
          readUserDetail['office'] = null;
          this.userDetail = readUserDetail;
        }
      }).catch(() => {
        // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
      });

      this.$nextTick(() => {
        if (this.userDetail) {
          // 既存ユーザーが更新するときに、CADソフト追加の対応で
          // https://github.com/Flew-createx/flew/issues/538
          if (this.userDetail.softwares) {
            for (let [key] of Object.entries(this.userDetail.softwares)) {
              if (key !== 'REVIT' && key !== 'VECTOR_WORKS') {
                if (!this.userDetail.softwares[key].children['0']) {
                  Object.assign(this.userDetail.softwares[key].children, {'0': {displayName: '2016以前', name: 0, version: 0, isSelected: false}});
                }
              }
            }
          }
          for (let [key] of Object.entries(SKILLS)) {
            for (let [childKey] of Object.entries(SKILLS[key].children)) {
              SKILLS[key].children[childKey] = this.userDetail['skills'] ? this.userDetail['skills'][key].children[childKey] : SKILLS[key].children[childKey];
            }
            SKILLS[key].isSelected = this.userDetail['skills'] ?  this.userDetail['skills'][key].isSelected : SKILLS[key].isSelected;
          }
          Object.assign(this.renewUserDetail.softwares, this.userDetail['softwares']);
          Object.assign(this.renewUserDetail.skills, SKILLS);
        }
        this.reloadKey = true;
      });
    },

    methods: {
      async updateUserDetail() {
        this.updateDoc(
          COLLECTION_NAMES.USER_DETAILS,
          this.uid,
          this.renewUserDetail
        ).then(async () => {
          this.showSuccessMessage('ユーザー情報を更新しました。');
          window.location.href = '/mypage/';
        }).catch(() => {
          // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
  .contents_wrapper {
    background: linear-gradient(45deg, $client_third, $client_third, $operator_secondary, $operator_secondary);

    > .contents {
      @include form-contents();
    }
  }
</style>